import React from "react";
import Slider from "slider";
import _HighlightProductByCategoryContainer from "./_HighlightProductByCategoryContainer.scss";
import Product from "components/partials/product";
import {Products} from "api";
import {Link} from 'react-router-dom';
import moment from 'moment';

class HighlightProductByCategoryContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      limit: 10,
      order: "id DESC"
    }
  }

  componentDidMount() {
    let params = {
      filter: {
        limit: this.state.limit,
        order: this.state.order,
        where: {
          isFeatured: true
        }
      }
    };
    Products.actions.list.request(params).then(response => {
      this.setState({
        data: response.data
      });
    });
  }

  render() {
    const settings = {
      className: "slider variable-width product-slick",
      dots: false,
      infinite: false,
      centerMode: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 701,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 551,
        settings: {
          slidesToShow: 2
        }
      }]
    };
    return (
      <section className="product-category-container">
        <div className="center">
          <div className='product-category-wrap'>
            <div className="product-left-content">
              <p className="product-icon">
                <i className="vtd-sp-nong-nghiep"/>
              </p>
              <p className="title-black">Sản phẩm tiêu biểu của Huế</p>
              {/* <p className="title-time"><span className='fa fa-clock'/>{moment().format('HH:mm:ss')}</p> */}
              {/* <p className="view-more"><Link to="/list-products/5a1af1d96c37814cbbb480cd" className="view-more-link">Xem thêm</Link></p> */}
            </div>
            <div className="product-right-content">
              <Slider {...settings}>
                {
                  this.state.data.map((item, i) => {
                    return (
                      <div key={i}>
                        <Product enableAddProduct={true} {...item}/>
                      </div>
                    );
                  })
                }
              </Slider>
            </div>
          </div>
          {/* <div className='wrap-ad'>
            <img src={require('assets/images/banner-ad-1.jpg')} className='img-responsive' alt=""/>
          </div> */}
        </div>
      </section>
    );
  }
}

export default HighlightProductByCategoryContainer;



// WEBPACK FOOTER //
// ./components/home/sub-view/HighlightProductByCategoryContainer.jsx